import Oracles from "./oracles";
import './Oracle.css';
import { useState } from "react";

export const Oracle = ({ oracles, name }: { oracles: Oracles; name: string; }) => {
    const [value, setValue] = useState(oracles.getRandomPromptFromOracleTable(name));
    // set a new value when the oracle is clicked
    const onClick = () => setValue(oracles.getRandomPromptFromOracleTable(name));

    return <div className='oracle' onClick={onClick}>
        <span className='oracle__name'>{name}</span>
        {typeof value === 'string' && <span className='oracle__prompt'>{value}</span>}
        {typeof value !== 'string' &&  <div>
            <span className='oracle__prompt'>{value.name}</span><br/>
            <span className='oracle__description'>{value.description}</span>
        </div>}
    </div>
}